import {FC} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {hasValue, IDocumentInfo} from '@kcast-fe/core';
import {Svg, TSvgName} from '@kcast-fe/ui-kit';

interface IProps {
  item: IDocumentInfo;
}

const IndexCellFC: FC<IProps> = ({item}) => {
  const renderIndex = (icon: TSvgName, index: boolean) => {
    return (
      <Box pos={'relative'}>
        <Svg name={icon} size={'s24'} />
        <Box
          p={'2px'}
          opacity={0.8}
          pos={'absolute'}
          borderRadius={'full'}
          bg={`{colors.${index ? 'stateSuccess' : 'stateError'}}`}
          color={'{colors.white}'}
          right={'-8px'}
          top={'-6px'}
        >
          <Svg name={index ? 'Check' : 'Close'} size={'s12'} />
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      {hasValue(item.index_state) ? (
        <Flex alignItems={'center'} gap={'16px'}>
          {renderIndex('OpenSearch', item.index_state.opensearch ?? false)}
          {renderIndex('MongoDB', item.index_state.mongo ?? false)}
          {renderIndex('Milvus', item.index_state.milvus ?? false)}
        </Flex>
      ) : (
        '—'
      )}
    </Box>
  );
};

export const IndexCell = IndexCellFC;
